export interface IDocumentSettings {
    ignoreFolderPatterns: string;
    ignoreFilePatterns: string;
    documentVersionAutoSaveHistorySize: number;
    documentVersionPublishHistorySize: number;
}

export class DocumentSettings implements IDocumentSettings {
    ignoreFolderPatterns: string;
    ignoreFilePatterns: string;
    documentVersionAutoSaveHistorySize: number;
    documentVersionPublishHistorySize: number;

    constructor();
    constructor(obj: IDocumentSettings);
    constructor(obj?: any) {
        this.ignoreFolderPatterns = obj && obj.ignoreFolderPatterns || "";
        this.ignoreFilePatterns = obj && obj.ignoreFilePatterns || "";
        this.documentVersionAutoSaveHistorySize = obj && obj.documentVersionAutoSaveHistorySize || 0;
        this.documentVersionPublishHistorySize = obj && obj.documentVersionPublishHistorySize || 0;
    }
}